import { FormattedMessage } from 'react-intl';

export const AvailableSizes = (
  <FormattedMessage defaultMessage='Available Size' id='sizes.availableSizes' />
);

export const SizeGuide = (
  <FormattedMessage defaultMessage='Size Guide' id='sizes.sizeGuide' />
);
